<div class="coupon-card-slim-vip-root" (click)="openCouponDetails()">
  <div class="left">
    <div
      class="title"
      [matTooltip]="
        coupon.business.businessName.length > 65
          ? coupon.business.businessName
          : ''
      "
      matTooltipClass="name-tooltip"
    >
      {{ coupon.business.businessName }}
    </div>
    <div class="discount">{{ coupon.discount }}% {{ labels.discount }}</div>
    <div class="vip-level">
      {{ coupon.vipName }}
    </div>
  </div>
  <div class="middle">
    <div class="code">
      <span class="title-label">{{ labels.code }}:</span>
      <span class="code">{{ coupon.code }}</span>
    </div>
    <div class="reseller">
      <span class="title-label">{{ labels.reseller }}:</span>
      <span class="reseller">
        <p>
          {{ coupon.resellerName }}
        </p>
      </span>
    </div>
    <div class="date">
      <span> {{ labels.issuedOn }} {{ coupon.startingDate | date : 'd MMM y' : '' : language }} </span>
      <span>
        {{ labels.expiresOn }} {{ coupon.expirationDate | date : 'd MMM y' : '' :language }}
      </span>
    </div>
  </div>
  <div class="right">
    <div class="points-area">
      <span
        *ngIf="coupon.active"
        class="status"
        [ngStyle]="{ color: getStatusColor(coupon.active) }"
      >
        {{ labels.active }}
      </span>
      <span
        *ngIf="!coupon.active"
        class="status"
        [ngStyle]="{ color: getStatusColor(coupon.active) }"
      >
        {{ labels.expired }}
      </span>
    </div>
    <div class="button-area">
      <app-secondary-button auxiliaryClean (click)="openCouponDetails()">
        {{ labels.seeCoupon }}
      </app-secondary-button>
    </div>
  </div>
</div>
